<template>
  <v-card
    max-width="100%"
    max-height="100%"
    variant="elevated"
    class="border"
    style="max-height: 100%; max-width: 100%; margin: 80px 500px; padding: 20px 0px 70px 0px;"
    elevation="24"
  >
    <v-card-text>
      <h2 class="d-flex justify-center">Logging You In...</h2>
      <br />
      <v-row no-gutters class="d-flex justify-center">
        <v-progress-circular
          class="my-2"
          indeterminate
          :size="50"
          :width="4"
          color="primary"
        >
          <v-col>
            <img src="../../assets/logo1.svg" width="20" alt="logo" />
          </v-col>
        </v-progress-circular>
      </v-row>
      <br /><br />
      <p class="d-flex text-center justify-center">
        We're now verifying your request and securely logging you into your account.
        <br />
        This process may take a few seconds. Please do not close this page or hit the back button.
        <br />
        Once the verification is complete, you'll be redirected automatically.
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import jwtDecode from "jwt-decode";
import api from "@/lib/api";
import localstorage from '@/lib/localstorage'

export default {
  name: "EmailAuthVerify",
  async mounted() {
  const q = this.$route.query.q;

  try {
    const jwtDecoded = jwtDecode(q);
    const cid = localStorage.getItem("cid");

    const payload = {
      cid: cid,
      user_id: jwtDecoded.user_id,
      code: jwtDecoded.code,
      url_validation: jwtDecoded.url_validation
    };

    const res = await api.POST("/user/auth/verify-url-login", payload);
    if (res.code === 200 && res.message === "success-login") {
      localStorage.setItem("token", res.data.token);

      const tokenDecoded = jwtDecode(res.data.token);
      if (tokenDecoded.cid) localStorage.setItem("cid", tokenDecoded.cid);
      if (tokenDecoded.role) localStorage.setItem("role", tokenDecoded.role);
      if (tokenDecoded.user_id) localStorage.setItem("uid", tokenDecoded.user_id);
      if (tokenDecoded.user_type) localStorage.setItem("type", tokenDecoded.user_type);

      let resProfile = await api.GET('user/profile')

      if (resProfile.data.email) localStorage.setItem("username", resProfile.data.email);
      localStorage.setItem("is_creator", resProfile.data.is_creator);
      localStorage.setItem("is_mfa_active", resProfile.data.is_mfa_active);

      if (res.data.enforce_password) {
        localStorage.setItem("force_change_password", true);
        setTimeout(() => {
          window.location.href = "/force-change-password";
        }, 3000);
        return;
      }

      const orgid = resProfile.data.organization_id;

      localStorage.setItem("orgid", orgid);
      localStorage.setItem("currentOrg", JSON.stringify(resProfile.data.organization))
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);
    } else {
      this.$store.dispatch("HOMEPAGE/showErrorToast", res.data.data, { root: true });
    }
    } catch (err) {
      
      let errmsg = "Verification failed";

      if (err.response && err.response.data && err.response.data.data) {
        errmsg = err.response.data.data;
      }

      this.$store.dispatch("HOMEPAGE/showErrorToast", errmsg, { root: true });
      setTimeout(() => {
        this.$router.push("/");
      }, 3000);
    }
  }
}
</script>
